import Paragraphe from "./Paragraphe";
import ParagrapheImager from "./ParagrapheImager";
import ParagrapheLister from "./ParagrapheLister";
import ParagrapheVitrine from "./ParagrapheVitrine";
import NodeBuilder from "./NodeBuilder"; // Ne pas build un NodeParagrapher dans un Paragraphe, risque de boucle
import Link from "./Link";

class ParagrapheBuilder {

    get(paragrapheData) {
        if (paragrapheData.type !== undefined) {
            let paragraphe = {};

            switch (paragrapheData.type) {
                case 'imager':
                    paragraphe = new ParagrapheImager(paragrapheData.title, paragrapheData.image);
                    paragraphe = this.checkUnrequiredParams(paragraphe, paragrapheData);
                    if (paragrapheData.imageDirection !== undefined) {
                        paragraphe.imageDirection = paragrapheData.imageDirection;
                    }
                    return paragraphe;

                case 'lister':
                    var nodeBuilder = new NodeBuilder(); // Déclaré parce qu'utilisé dans une boucle map
                    paragraphe = new ParagrapheLister(paragrapheData.title);
                    paragraphe = this.checkUnrequiredParams(paragraphe, paragrapheData);
                    paragraphe.components = paragrapheData.components.map(component => nodeBuilder.get(component));
                    return paragraphe;

                case 'vitrine':
                    paragraphe = new ParagrapheVitrine(paragrapheData.title, paragrapheData.items);
                    paragraphe = this.checkUnrequiredParams(paragraphe, paragrapheData);
                    return paragraphe;

                default:
                    paragraphe = new Paragraphe(paragrapheData.type, paragrapheData.title);
                    paragraphe = this.checkUnrequiredParams(paragraphe, paragrapheData);
                    return paragraphe;
            }
        }

        return new Paragraphe(0, "", "");
    }

    checkUnrequiredParams(paragraphe, paragrapheData) {
        if (paragrapheData.body) {
            paragraphe.body = paragrapheData.body
        }
        if (paragrapheData.color !== undefined) {
            paragraphe.color = paragrapheData.color
        }
        if (paragrapheData.link !== undefined) {
            paragraphe.link = new Link(paragrapheData.link.url, paragrapheData.link.label, paragrapheData.link.color, paragrapheData.link.direction);
        }
        return paragraphe;
    }
}

export default ParagrapheBuilder;